export default __webpack_public_path__ + "static/media/flowIcon.9d9bb5be.png";